module.exports = __webpack_public_path__ + "static/assets/422b48c2206d5240a6717c92496ba21a.svg";